import { createFeatureSelector, createSelector, type MemoizedSelector } from '@ngrx/store';
import type { Branding } from '../../interfaces/Branding.interface';
import type { AppState } from '../app.state';
import type { State } from './branding.state';

const getIsPending = (state: State): boolean => state.isPending;
const getIsLoaded = (state: State): boolean => state.isLoaded;
const getBranding = (state: State): Branding | null => state.branding;

export const selectBrandingState: MemoizedSelector<AppState, State> = createFeatureSelector('branding');

export const selectIsPending: MemoizedSelector<AppState, boolean> = createSelector(selectBrandingState, getIsPending);
export const selectIsLoaded: MemoizedSelector<AppState, boolean> = createSelector(selectBrandingState, getIsLoaded);
export const selectBranding: MemoizedSelector<AppState, Branding | null> = createSelector(
    selectBrandingState,
    getBranding
);
